import SettingsIcon from "@mui/icons-material/Settings";
import { MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { forwardRef } from "react";
import { useUserMenu } from "react-admin";
import { Link } from "react-router-dom";

export const SettingsMenuItem = forwardRef<HTMLAnchorElement>((props, ref) => {
  const userMenuContext = useUserMenu();
  if (!userMenuContext) {
    throw new Error("<SettingsMenuItem> should be used inside a <UserMenu>");
  }
  const { onClose } = userMenuContext;
  return (
    <MenuItem
      onClick={onClose}
      ref={ref}
      component={Link}
      to="/settings"
      {...props}
    >
      <ListItemIcon>
        <SettingsIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Settings</ListItemText>
    </MenuItem>
  );
});

SettingsMenuItem.displayName = "SettingsMenuItem";
